// @mui
import { styled } from '@mui/material/styles';
import { useEffect, useContext } from 'react';
import { Typography, Container, Stack, Card, Grid, Switch } from '@mui/material';
// components
import Page from '../../components/Page';
import instance from '../../api/axiosRequest';
import { MyContext } from '../../layouts/dashboard';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(() => ({
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column'
}));

// ----------------------------------------------------------------------

// button

const Button = (props) => (
  <button type="button" style={{
    backgroundColor: "blue",
    color: "white",
    fontSize: "0.9em",
    paddingInline: 16,
    border: "none",
    cursor: "pointer"
  }} {...props}/>
)

const label = { inputProps: { 'aria-label': 'Switch demo' } };

export default function UserDetails() {

  const { row } = useContext(MyContext)

  useEffect(() => {
    const getProfile = async() => {
      await instance.get('/vendor/profile')
    }
    if(row.role !== 1)
getProfile()
  },[row]);

  return (
    <Page title="Profile">
      <Container>
        <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
       <div style={{width: "100%",textAlign: "right"}}>
      <Switch {...label} defaultChecked />
      Disable user
        </div>
          <Typography variant="h3" paragraph>
            Details
          </Typography>
          <Card sx={{ width: "100%", p:2}}>
            <Grid container spacing={0}>
            <Grid item xs>
                <Stack alignItems="start">
                  <Typography><b>Name</b></Typography>
                  <Typography><b>Email</b></Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack alignItems="start">
                  <Typography>{row.name}</Typography>
                  <Typography>{row.email}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Card>

          <h2 style={{color: "blue", marginTop: 36}}>Credentials</h2>
                <Stack mt={2} sx={{ width: "100%"}} direction="row" justifyContent="space-between">
                  <Typography><b>ClientID</b></Typography>
                  <Typography><b>XXXXX789</b></Typography>
                  <Button>VIEW</Button>
                </Stack>
                <Stack mt={2} sx={{ width: "100%"}} direction="row" justifyContent="space-between">
                  <Typography><b>Secret Key</b></Typography>
                  <Typography><b>XXXXXXX</b></Typography>
                  <Button>VIEW</Button>
                </Stack>
        </ContentStyle>
      </Container>
    </Page>
  );
}
